/* ---------------------------------------

    -- マウスのモーション

--------------------------------------- */

export default class MouseMotion {
    constructor(param, effect) {
        this.$target

        this.status = {
            mode: 'default',
            scale: false,
            op: false,
        }
    }
    scaleUP($target) {
        if (this.status.scale) return
        this.status.scale = true

        TweenMax.to($target, 0.4, {
            scale: 5,
        })
    }
    scaleDown($target) {
        if (!this.status.scale) return
        this.status.scale = false
        TweenMax.to($target, 0.4, {
            scale: 1,
        })
    }
    opShow($target) {
        // if (this.status.op) return
        // this.status.op = true
        TweenMax.to($target, 0.4, {
            opacity: 1,
            scale: 1
        })
    }
    opOut($target) {
        // if (!this.status.op) return
        // this.status.op = false
        TweenMax.killTweensOf($target,{
            opacity:true,
            scale:true
        })
        TweenMax.to($target, 0.4, {
            opacity: 0,
            scale: 0.5
        })
    }
    arrowRot($target, dir) {
        TweenMax.to($target, 0.4, {
            rotationY: dir == 'next' ? 0 : 180,
        })
    }
}
